/* eslint-disable unicorn/no-unsafe-regex */
import { Input } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { pressOnlyRegEx } from '../../../../../../../../../../../../lib/util/helpers';
import styles from './CounterInput.module.scss';
import classNames from 'classnames';

const normalizeInputValue = value => value.replaceAll(/\D/g, '');

/**
 * @desc Counter Input
 * @param {Object} answer
 * @param {Function} handleChange
 * @param {Boolean} showCurrencySymbol
 * @param {String} currencySymbol
 * @param {Object} textStyle
 * @param {String} className
 * @param {RegExp} regEx
 * @param {Boolean} disabled
 * @param {String} primaryColor
 * @returns {JSX.Element}
 */
export function CounterInput({
  answer,
  handleChange,
  showCurrencySymbol,
  currencySymbol,
  textStyle,
  className,
  regEx = /\d/,
  disabled,
  primaryColor,
}) {
  const counterInputClassList = classNames(
    styles.counterInputContainer,
    showCurrencySymbol ? styles.hasCurrency : '',
    currencySymbol?.length > 1 ? styles.longCurrency : ''
  );

  const primarycolor = primaryColor;
  const [inputValue, setInputValue] = useState(String(answer.amount ?? ''));

  useEffect(() => {
    setInputValue(String(answer.amount ?? ''));
  }, [answer.amount]);

  const formatInputValue = value => {
    if (value === '') {
      return '';
    }

    const formattedValue = String(value).replace(/\B(?=(?:\d{3})+(?!\d))/g, '.');
    return `${answer.maxValueText && Number(value) === answer.maxValue ? '> ' : ''}${formattedValue}`;
  };

  const handleInputChange = event => {
    const normalizedValue = normalizeInputValue(event.target.value);

    setInputValue(normalizedValue);

    if (normalizedValue !== '') {
      handleChange(Number(normalizedValue));
    }
  };

  const handleBlur = () => {
    if (inputValue === '') {
      handleChange(answer.minValue);
      setInputValue(String(answer.minValue));
    }
  };

  return (
    <div className={counterInputClassList}>
      <div className={styles.currencyContainer}>{currencySymbol}</div>
      <StyledInput
        primarycolor={primarycolor}
        className={className}
        style={textStyle}
        value={formatInputValue(inputValue)}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyPress={event => pressOnlyRegEx(event, regEx)}
        disabled={disabled}
      />
    </div>
  );
}

const StyledInput = styled(Input)(({ primarycolor }) => ({
  ':focus-within, :hover': {
    borderColor: `${primarycolor} !important`,
    boxShadow: `0 0 0 2px ${primarycolor}20`,
  },

  input: {
    boxSizing: 'border-box',
    margin: 0,
    padding: '0 8px',
    color: 'inherit',
    fontSize: 'inherit',
    lineHeight: 1.2,
    listStyle: 'none',
    fontFamily: 'inherit',
    width: '100%',
    height: '38px',
    textAlign: 'center',
    backgroundColor: 'transparent',
    border: 0,
    borderRadius: '8px',
    outline: 0,
    transition: 'all 0.2s linear',
  },
}));
